import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/authContext';
import AdminNewsForm from '../components/AdminNewsForm';
import { API_BASE_URL } from '../utils/api/config';
import './AdminPages.css';

/**
 * EditNews Page
 * Admin page for editing existing news articles
 */
function EditNews() {
  const { id } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [news, setNews] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchNews = useCallback(async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${API_BASE_URL}/news/id/${id}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          }
        }
      );

      const data = await response.json();
      if (data.success) {
        setNews(data.data);
      } else {
        setError(data.message || 'समाचार लोड करने में विफल');
      }
    } catch (error) {
      console.error('Error fetching news:', error);
      setError('समाचार लोड करने में विफल');
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  // Check admin authorization
  if (!user || user.role !== 'admin') {
    return (
      <div className="admin-page error">
        <div className="error-container">
          <h2>अनुमति नहीं है</h2>
          <p>इस पृष्ठ को देखने के लिए आपको व्यवस्थापक होना चाहिए</p>
        </div>
      </div>
    );
  }

  if (loading) {
    return <div className="admin-page"><div className="loading">लोड हो रहा है...</div></div>;
  }

  if (error) {
    return (
      <div className="admin-page error">
        <div className="error-container">
          <h2>❌ त्रुटि</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/admin/news/add')} className="btn-primary">
            वापस जाएं
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page edit-news">
      <div className="admin-header">
        <h1>✎ समाचार संपादित करें</h1>
      </div>

      <div className="admin-content">
        {news && (
          <AdminNewsForm 
            mode="edit" 
            initialData={news}
            onSuccess={() => navigate('/admin/news/add')}
          />
        )}
      </div>
    </div>
  );
}

export default EditNews;
